<template>
  <div class="TableTemplate" :class="{content: !rawTable, viewportHeight, removeCardStyle}" :id="id">

    <div :class="{'container-fluid': !rawTable}">
    
      <NewItemAlert v-if="newlyCreatedAlertKey"
        :alert-key="newlyCreatedAlertKey"

        class="mb-3"
      >
        <template #default="props">
          <slot name="new-item-alert-content" v-bind='props'></slot>
        </template>
      </NewItemAlert>

      <div class="content-wrapper flex-column">

        <div class="pb-2">
          <slot name="above"></slot>
        </div>
        <div class="content-wrapper card-wrapper">
          <card class="raw-table-body"
            :class="{removeCard}"
            :body-classes="[
              'table-full-width table-responsive card-body',
              {
                'raw-table-body': rawTable,
              },
              cardClass, removeCard,
            ]"
          >
            <div class="table-content">
              <div v-if="!removeHeader" class='header-wrapper'>
                <slot></slot>
              </div>

              <ImageGallery
                v-model="mainIndex"
                :images="galleryImages"
              >
                <l-table v-if="useOldTable" class="table"
                  :data="value"
                  :class="tableClass"

                  :removeCursor='removeCursor'
                  :columns="columns"
                  :columnVariables="columnVariables"
                  :capitalize="capitalize"
                  :skeletonClass="skeletonClass"
                  :remove-skeleton-array="removeSkeletonArray"

                  :enable-sorting="enableSorting"
                  :disable-loading-content="disableLoadingContent"
                  :columnConfigurationId="columnConfigurationId"
                  :fieldsWithCommas="fieldsWithCommas"
                  :selected="selected"
                  :dragDisabledOnColumns="dragDisabledOnColumns"
                  :heightLimit="heightLimit"

                  :sort="sort"
                  :order="order"

                  @update-column-order="v => $emit('update-column-order', v)"
                  @set-sort="setSort"
                  @set-order="setOrder"
                  @row-click="item => $emit('row-click', item)"
                >
                  <template v-for="url in imageUrls"
                    v-slot:[`${url}`]="{value, rowIndex, isLoading, styles}"
                  >
                    <TableCell :skeleton-class="skeletonClass" :style="styles">
                      <span :class="(loadedImageUrls || value !== '---') ? '' : 'ske'">
                        <!-- <FullPageImageOption v-if="value !== '---'" class="image-expander"> -->
                          <span v-if="isLoading">
                            {{ value }}
                          </span>
                          <img v-else-if="value !== '---'"
                            class="image-expander"
                            :src="value"

                            width="auto"
                            height="50"

                            @click="openGalery(url, rowIndex)"
                          />
                        <!-- </FullPageImageOption> -->
                        <div v-else class="d-flex align-items-center" style="width: 50px;height: 50px">
                          ---
                        </div>

                      </span>
                    </TableCell>
                  </template>

                  <template #table-header>
                    <div v-if="isSelectingColumns && !removeCheckboxes"
                      class="d-flex align-items-center"
                      id="multi-select-handle"

                      @click="selectAllCheckboxes"
                    >
                      <FormCheckbox :value='hasAllItemsSelected'
                        :disable-toggle="true"

                        class="multiple-select-checkbox"
                        :class="{active: hasAllItemsSelected}"
                      ></FormCheckbox>
                    </div>
                  </template>

                  <template #column-select="{selected, item}">
                    <div v-if="isSelectingColumns && !removeCheckboxes"
                      class="d-flex align-items-center"
                      style="background-color: #FBFBFB !important"
                    >
                      <FormCheckbox :value='selected'
                        class="multiple-select-checkbox"
                        :class="{active: selected}"
                      ></FormCheckbox>
                    </div>
                  </template>

                  <template #before-row="{item}">
                    <slot name="before-row" :item="item"></slot>
                  </template>

                  <template v-for="(_, name) in $scopedSlots"
                    slot-scope="slotData"
                    :slot="name"

                    v-if="name"
                  >
                    <slot
                      :name="name"

                      v-bind="slotData"
                    />
                  </template>

                  <template v-for="slot in extendedSlots"
                    slot-scope="slotData"
                    :slot="slot.slot"
                  >
                    <slot
                      :name="slot.name"
                      :extendedSlot="true"

                      v-bind="{...slotData, ...slot.props}"
                    />
                  </template>
                </l-table>
                <ComposableTable v-else
                  :data="value"
                  :columns="columns"
                  :variables="columnVariables"

                  :id="id"
                  :enable-sort-by-specific-column="enableSorting"
                  :sort="sort"
                  :dateFormat="dateFormat"
                  :order="order"
                  :onRowClick="onRowClick"
                  :selected="selected"
                  :columnConfigurationId="columnConfigurationId"
                  :removeTableHeader="removeTableHeader"

                  :enableColumnResize="true"
                  :dragDisabledOnColumns="dragDisabledOnColumns"

                  @set-sort="setSort"
                  @set-order="setOrder"
                  @update-column-order="v => $emit('update-column-order', v)"
                >
                  <template v-for="url in imageUrls"
                      v-slot:[`cell-${url}`]="{value, rowIndex, isLoading, styles}"
                    >
                      <TableCell :skeleton-class="skeletonClass" :style="styles">
                        <span :class="(loadedImageUrls || value !== '---') ? '' : 'ske'">
                          <!-- <FullPageImageOption v-if="value !== '---'" class="image-expander"> -->
                            <span v-if="isLoading">
                              {{ value }}
                            </span>
                            <img v-else-if="value !== '---'"
                              class="image-expander"
                              :src="value"

                              width="auto"
                              height="50"

                              @click="openGalery(url, rowIndex)"
                            />
                          <!-- </FullPageImageOption> -->
                          <div v-else class="d-flex align-items-center" style="width: 50px;height: 50px">
                            ---
                          </div>

                        </span>
                      </TableCell>
                    </template>  
                
                  <template v-for="(_, name) in $scopedSlots"
                    slot-scope="slotData"
                    :slot="name"

                    v-if="name"
                  >
                    <slot
                      :name="name"

                      v-bind="slotData"
                    />
                  </template>

                  <template #table-header="{isLoading}">
                    <div v-if="isSelectingColumns && !removeCheckboxes"
                      class="d-flex align-items-center"
                      id="multi-select-handle"

                      @click="selectAllCheckboxes"
                    >
                      <FormCheckbox :value='hasAllItemsSelected'
                        :disable-toggle="true"
                        :is-loading="isLoading"

                        class="multiple-select-checkbox"
                        :class="{active: hasAllItemsSelected}"
                      ></FormCheckbox>
                    </div>
                  </template>

                  <template #column-select="{selected, isLoading, item}">
                    <div v-if="isSelectingColumns && !removeCheckboxes"
                      class="d-flex align-items-center"
                      style="background-color: #FBFBFB !important"

                      @click="selectRow(item)"
                    >
                      <FormCheckbox :value='selected'
                        class="multiple-select-checkbox"
                        :class="{active: selected}"

                        :is-loading="isLoading"
                        :disable-toggle="true"
                      ></FormCheckbox>
                    </div>
                  </template>

                  <template #before-row="{item}">
                    <slot name="before-row" :item="item"></slot>
                  </template>

                  <template v-for="slot in extendedSlots"
                    slot-scope="slotData"
                    :slot="`cell-${slot.slot}`"
                  >
                    <slot
                      :name="`cell-${slot.name}`"
                      :extendedSlot="true"

                      v-bind="{...slotData, ...slot.props}"
                    />
                  </template>
                </ComposableTable>
              </ImageGallery>
            </div>

            <div v-if="!hidePagination" class="PaginationWrapper d-flex justify-content-center pagination-wrapper">
              <Pagination
                :max="max"

                :value="page"
                @input="setPage"
              />
            </div>
          </card>
          <div>
            <slot name="right-column"></slot>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import StatsCard from 'src/components/Cards/StatsCard.vue'
import LTable from 'src/components/Table/Table.vue'
import Card from 'src/components/Cards/Card.vue'
import Pagination from 'src/layout/Pagination.vue'
import TableCell from "src/components/Table/TableCell.vue"

import ImageGallery from '../Modals/ImageGallery.vue'
import TableSearchField from 'src/components/Inputs/TableSearchField.vue'
import FormSelect from "src/components/Inputs/FormSelect.vue"
import FormCheckbox from "/src/components/Inputs/FormCheckbox.vue"
/* import FullPageImageOption from '../ImageExpanderModal.vue' */
import NewItemAlert from '../NewItemAlert.vue'
import ComposableTable from '../../components/Product/ComposableTable/ComposableTable.vue'

export default {
  components: {
    FormCheckbox,
    NewItemAlert,
    TableSearchField,
    FormSelect,
    Pagination,
    ComposableTable,
    TableCell,
    ImageGallery,
    // FullPageImageOption,
    Card,
    LTable,
    StatsCard
  },
  props: {
    dateFormat: String,
    noTimeDateFormat: Boolean,
    newlyCreatedAlertKey: String,
    viewportHeight: Boolean,
    removeCardStyle: Boolean,
    removeTableHeader: Boolean,
    disableLoadingContent: Boolean,
    dragDisabledOnColumns: Array,
    removeSkeletonArray: Boolean,
    useOldTable: Boolean,
    onRowClick: Function,
    heightLimit: String,
    id: String,
    extendedSlots: Array,

    enableSorting: {
      type: Boolean,
      required: false,
    },
    fieldsWithCommas: {
      type: Array,
      required: false,
    },
    selected: {
      type: Array,
      required: false,
    },
    removeCursor: {
      type: Boolean,
      required: false,
    },
    scrollingLimit: {
      type: Number,
      required: false,
    },
    removeHeader: {
      type: Boolean,
      required: false,
    },
    firstColumnPadding: {
      type: Boolean,
      required: false,
    },
    removeCard: {
      type: Boolean,
      required: false,
    },
    cardClass: {
      type: String,
      required: false,
    },
    tableClass: {
      type: String,
      required: false,
    },
    hidePagination: {
      type: Boolean,
      required: false,
    },
    rawTable: {
      type: Boolean,
      required: false,
    },
    removeCheckboxes: Boolean,
    skeletonClass: {
      type: [String, Object],
      required: true,
    },
    value: {
      type: [Array, String],
      required: false,
    },
    columns: {
      type: Array,
      required: true,
    },
    columnVariables: {
      type: Array,
      required: true,
    },
    capitalize: {
      type: Array,
      required: false,
    },
    max: {
      type: Number,
      required: false,
    },
    page: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      mainIndex: null,
      galleryImages: [],
    }
  },
  methods: {
    selectRow(item) {
      const id = item.sku || item.id
      
      if (this.selected.includes(id)) {
        this.selected.splice(this.selected.indexOf(id), 1)
      } else {
        this.selected.push(id)
      }
    },
    
    // @click="openGalery(url, rowIndex)"
    openGalery(key, rowIndex) {
      this.galleryImages = this.value.map(item => item[key])
      const targetImg = this.galleryImages[rowIndex]
      this.galleryImages = this.galleryImages.filter(item => item)
      this.mainIndex = this.galleryImages.findIndex(url => url === targetImg)
    },

    selectAllCheckboxes() {
      const selected = this.selected
      const allSelected = this.hasAllItemsSelected
      while (selected.length) {
        selected.pop()
      }

      if (!allSelected) {
        this.value.forEach(item => {
          selected.push(item.uid || item.sku)
        })
      }
    },

    setPage(page) {
      this.$emit("set-page", page)
    },
    getVmValue(fieldName) {
      return this.$parent[fieldName]
    },
    assignVmValue(fieldName, value) {
      this.$parent[fieldName] = value
    },

    setSort(sort) {
      this.$parent.sort = sort
    },
    setOrder(order) {
      this.$parent.order = order
    },
  },
  computed: {
    hasAllItemsSelected() {
      const selected = this.selected
      return this.value && this.value.every && this.value.length && selected && selected.every && this.value.every(item => selected.includes(item.uid || item.sku))
    },

    isSelectingColumns() {
      return this.$parent.selecting
    },
    columnConfigurationId() {
      return this.$parent.columnConfigurationId
    },
    hasColumnConfigurationOptions() {
      return this.$parent.hasTemplateConfiguration
    },
    tableColumnVariables() {
      return this.$parent.tableColumnVariables
    },
    imageUrls() {
      return this.$parent.imageUrls
    },
    loadedImageUrls() {
      return this.$parent.loadedImageUrls
    },
    sort() {
      return this.$parent.sort
    },
    order() {
      return this.$parent.order
    },
    customOrder() {
      return this.$parent.customOrder
    },
  },
}

</script>

<style>

@media (max-width: 575px) {
  .table-responsive {
    padding-left: 0 !important;
  }
}

.TableTemplate .card-body {
  display: flex;
  flex-direction: column;
  padding: 0px !important;
  margin: 0px !important;
  box-sizing: border-box;
}

.table-content {
  flex-grow: 1;
}

.TableTemplate .form-group {
  margin-bottom: 0px;
}

.removeCard {
  border: none !important;
}

</style>

<style scoped>

.image-expander {
  height: 50px;
  filter: brightness(1);
  transition-duration: .2s;
  cursor: pointer;
}

.image-expander:hover {
  filter: brightness(.6);
}

img {
  height: 100%;
  width: auto;
}

.image-cell {
  padding: 0px;
}

.TableTemplate, .TableTemplate > div, .content-wrapper, .raw-table-body, .card-body {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
}

.TableTemplate.viewportHeight, .viewportHeight.TableTemplate > div, .viewportHeight .content-wrapper,  .viewportHeight .raw-table-body, .viewportHeight .card-body {
  height: 100vh !important;
  min-height: unset;
}

.viewportHeight .raw-table-body, .viewportHeight .card-body {
  height: auto !important;
}

.TableTemplate {
  overflow: visible !important;
  width: 100%;
}

.viewportHeight.TableTemplate {
  overflow: auto !important;
}

.content-wrapper {
  display: flex;
}

.raw-table-body {
  padding: 0px !important;
  margin: 0px !important;
  flex-basis: 100%;
  flex-grow: 1;
}

.header-wrapper {
  padding: 0px;
}

.table {
  flex-grow: 1;
}

.TableTemplate {
  overflow: auto;
  display: flex;
}

.pagination-wrapper {
  margin-top: 24px;
  margin-bottom: 24px;
}

.custom-select {
  border: none;
  outline: 0;
}

.TableTemplate.removeCardStyle .card {
  border: none !important;
}

.TableTemplate.removeCardStyle th {
  border-left: none;
}

</style>
